// 예약 작업 목록 - sm 이상은 표, xs(휴대폰)는 카드로 쌓는다. 행/카드를 누르면 그 밑에
// 최근 실행 이력이 펼쳐진다(SysJobRunHistory). 둘 다 같은 리스트/핸들러를 공유한다.
import React, { useMemo } from 'react';
import {
  Box, Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  Collapse, Alert, CircularProgress, Typography, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SysJobTableRow, SysJobCard } from './SysJobRow';
import SysJobRunHistory from './SysJobRunHistory';

const SysJobsBoard = ({
  list, loading, expandedJobId, onToggleExpand, onRun, runningJobId,
  runHistory, runHistoryLoading, runHistoryPage, runHistorySize, runHistoryTotal, onRunHistoryPageChange,
}) => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));

  const empty = !loading && (!list || list.length === 0);

  const historyPanel = useMemo(() => (jobId) => (
    <SysJobRunHistory
      runs={expandedJobId === jobId ? runHistory : []}
      total={runHistoryTotal}
      page={runHistoryPage}
      size={runHistorySize}
      loading={runHistoryLoading}
      onPageChange={onRunHistoryPageChange}
    />
  ), [expandedJobId, runHistory, runHistoryTotal, runHistoryPage, runHistorySize, runHistoryLoading, onRunHistoryPageChange]);

  if (loading && (!list || list.length === 0)) {
    return <Box sx={{ py: 6, textAlign: 'center' }}><CircularProgress size={28} /></Box>;
  }

  if (empty) {
    return <Alert severity="info">등록된 예약 작업이 없습니다.</Alert>;
  }

  if (isPhone) {
    return (
      <Box>
        {list.map((job) => (
          <Box key={job.jobId}>
            <SysJobCard
              job={job}
              onClick={() => onToggleExpand(job)}
              onRun={onRun}
              running={runningJobId === job.jobId}
              expanded={expandedJobId === job.jobId}
            />
            <Collapse in={expandedJobId === job.jobId} unmountOnExit>
              <Box sx={{ mb: 2, px: 1 }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                  최근 실행 이력
                </Typography>
                {historyPanel(job.jobId)}
              </Box>
            </Collapse>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>이름</TableCell>
            <TableCell>종류</TableCell>
            <TableCell>주기</TableCell>
            <TableCell>최근 실행</TableCell>
            <TableCell>최근 성공</TableCell>
            <TableCell>다음 실행</TableCell>
            <TableCell align="right">실행</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((job) => (
            <React.Fragment key={job.jobId}>
              <SysJobTableRow
                job={job}
                onClick={() => onToggleExpand(job)}
                onRun={onRun}
                running={runningJobId === job.jobId}
                expanded={expandedJobId === job.jobId}
              />
              <TableRow>
                <TableCell colSpan={7} sx={{ py: 0, borderBottom: expandedJobId === job.jobId ? undefined : 'none' }}>
                  <Collapse in={expandedJobId === job.jobId} unmountOnExit>
                    <Box sx={{ py: 1.5 }}>{historyPanel(job.jobId)}</Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SysJobsBoard;
